import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ecosystemCards } from '../../../mocks/beaData';
import useScrollReveal from '@/hooks/useScrollReveal';

const EcosystemSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  useScrollReveal(ref);

  const statColors = ['#F0C808', '#ffffff', '#F0C808', '#ffffff'];

  return (
    <section ref={ref} className="bg-bteal py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div data-reveal data-delay="1" className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-4">
          <div>
            <span className="text-[11px] font-bold text-white/50 tracking-widest uppercase">02 — The Ecosystem</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight tracking-tight mt-1">
              Bihar&apos;s Ethanol Ecosystem
            </h2>
          </div>
          <Link
            to="/ecosystem"
            className="inline-flex items-center gap-2 text-sm font-semibold text-white/70 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer"
          >
            Explore Full Ecosystem
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </Link>
        </div>

        {/* Rows */}
        <div className="mt-10">
          {ecosystemCards.map((card, i) => (
            <div
              key={card.id}
              data-reveal
              data-delay={String(i + 1)}
              className="border-t border-white/20 py-7 grid grid-cols-[56px_1fr_auto] md:grid-cols-[64px_1fr_auto] gap-5 md:gap-10 items-start group cursor-default hover:bg-white/5 -mx-6 px-6 md:-mx-10 md:px-10 transition-colors duration-200"
            >
              {/* Step number */}
              <span className="text-5xl font-black text-white/15 leading-none pt-1 group-hover:text-white/25 transition-colors duration-200">
                {(i + 1).toString().padStart(2, '0')}
              </span>

              {/* Content */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 flex items-center justify-center rounded bg-white/10">
                    <i className={`${card.icon} text-white text-xs`} />
                  </span>
                  <h3 className="font-semibold text-white text-base">{card.title}</h3>
                </div>
                <p className="text-white/55 text-sm leading-relaxed">{card.description}</p>
              </div>

              {/* Stat */}
              <div className="text-right shrink-0 pt-1">
                <p className="text-xl md:text-2xl font-bold leading-none" style={{ color: statColors[i] }}>{card.stat}</p>
                <p className="text-white/40 text-[10px] mt-1 uppercase tracking-wide">{card.statLabel}</p>
              </div>
            </div>
          ))}
          <div className="border-t border-white/20" />
        </div>
      </div>
    </section>
  );
};

export default EcosystemSection;
